import { getSrc } from 'gatsby-plugin-image';
import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';
import _isString from 'lodash/isString';
import { isGatsbyImage } from './gatsby';

/**
 *
 * @param {ImagePropType} image
 * @returns a URL for the image
 */
export function getImageSrc(image) {
  if (_isNil(image)) {
    return null;
  }
  if (_isString(image)) {
    return image;
  }
  if (_isObject(image) && image.url) {
    var url = image.url;
    return getImageSrc(url);
  }
  if (isGatsbyImage(image)) {
    return getSrc(image);
  }
  if (_isObject(image) && image.gatsbyFile) {
    var gatsbyFile = image.gatsbyFile;
    return getImageSrc(gatsbyFile);
  }
  return null;
}

/**
 *
 * @param {ImagePropType} image
 * @returns a unique id of the image, to be used as key in JSX for-loops
 */
export function getImageKey(image) {
  return getImageSrc(image);
}